import { render } from "./SupportView.vue?vue&type=template&id=36daf8ec&scoped=true&ts=true"
import script from "./SupportView.vue?vue&type=script&lang=ts"
export * from "./SupportView.vue?vue&type=script&lang=ts"

import "./SupportView.vue?vue&type=style&index=0&id=36daf8ec&scoped=true&lang=css"
import "./SupportView.vue?vue&type=style&index=1&id=36daf8ec&lang=css"
import "./SupportView.vue?vue&type=style&index=2&id=36daf8ec&lang=css"
import "./SupportView.vue?vue&type=style&index=3&id=36daf8ec&lang=css"
import "./SupportView.vue?vue&type=style&index=4&id=36daf8ec&lang=css"
import "./SupportView.vue?vue&type=style&index=5&id=36daf8ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36daf8ec"]])

export default __exports__